import React, { Component } from 'react';
import { View } from 'react-native';

import { VFText, VFButton, Icon } from '@vfgroup-oneplatform/foundation/Components';
import {
  withTheme,
  Images,
  LightThemeColors,
} from '@vfgroup-oneplatform/foundation/Components/Themes';
import VFLottieView, { LottieTypes } from '@vfgroup-oneplatform/foundation/Components/VFLottieView';
import PropTypes from 'prop-types';

import LoginTestKeys from '../../../Utils/LoginTestKeys';

import styles from './RemoveAccountResult.Styles';

class RemoveAccountResult extends Component {
  render() {
    const {
      savedAccounts,
      onDeleteAccountConfirmPress,
      isRemoveAccountFinishedSuccess,
      selectedAccount,
      onReturnToAccountsPress,
      onReturnToSignInPress,
      theme,
    } = this.props;
    const sourceImage = isRemoveAccountFinishedSuccess ? null : Images.ic_WarningHiLight_Theme;
    const lottietype = isRemoveAccountFinishedSuccess ? LottieTypes.tick : null;
    const title = isRemoveAccountFinishedSuccess
      ? 'confirm_remove_account_account_removed_label'
      : 'confirm_remove_account_something_went_wrong_label';
    const subTitle = isRemoveAccountFinishedSuccess
      ? 'confirm_remove_account_you_have_successfully_removed_label'
      : 'confirm_remove_account_you_could_not_remove_account_label';
    const titlePlaceHolders = [selectedAccount.name];
    const subTitlePlaceHolders = [selectedAccount.name];
    const isSavedAccountsEmpty = (savedAccounts || []).length === 0;

    return (
      <View style={[styles.containerCenter]}>
        {sourceImage && <Icon name={sourceImage} type="image" style={styles.sourceImage} />}
        {lottietype && (
          <VFLottieView
            autoPlay
            style={styles.lottieView}
            type={lottietype}
            loop={false}
            isReward
            lottieViewTestID={LoginTestKeys.successIcon}
          />
        )}
        {title && (
          <View style={styles.headerContainer}>
            <VFText
              style={[styles.responseTitle(theme)]}
              i18nKey={title}
              placeHolders={titlePlaceHolders}
            />
          </View>
        )}
        {subTitle && (
          <VFText
            style={[styles.subTitle(theme, !isRemoveAccountFinishedSuccess), styles.alignCenter]}
            i18nKey={subTitle}
            placeHolders={subTitlePlaceHolders}
          />
        )}
        {!isRemoveAccountFinishedSuccess && (
          <VFButton
            title={'top_up_quick_action_error_button'}
            style={styles.modalButton}
            textStyle={styles.modalButtonText}
            type={'secondary'}
            onPress={() => onDeleteAccountConfirmPress()}
          />
        )}
        <VFButton
          title={
            isSavedAccountsEmpty
              ? 'registered_account_edit_dialog_button'
              : 'confirm_remove_account_return_to_accounts_button'
          }
          style={styles.modalButton}
          textStyle={styles.modalButtonText}
          type={'primary'}
          onPress={isSavedAccountsEmpty ? onReturnToSignInPress : onReturnToAccountsPress}
          testKey={LoginTestKeys.returnToYourAccountsBtn}
        />
      </View>
    );
  }
}
RemoveAccountResult.defaultProps = {
  theme: LightThemeColors,
};
RemoveAccountResult.propTypes = {
  theme: PropTypes.object,
  savedAccounts: PropTypes.array,
  onDeleteAccountConfirmPress: PropTypes.func,
  isRemoveAccountFinishedSuccess: PropTypes.bool,
  selectedAccount: PropTypes.object,
  onReturnToAccountsPress: PropTypes.func,
  onReturnToSignInPress: PropTypes.func,
};
export default withTheme(RemoveAccountResult);
